let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6tWAg")).then(() => parcelRequire('81BX8'));